import {Material} from "@/model/material";

export interface ITheme {
    theme_id: string,
    internal_name: string,
    tags: string[],
    head_image_template_id: string,
    background_image_url: string,
    applet_poster_image_template_ids: string[],
    applet_share_thumb_image_template_ids: string[],
    publish_at: string | null,
    delete_at: string | null,
}

export class Themes {
    constructor(public readonly material: Material, public readonly data: { [key: string]: ITheme }) {
    }

}
